import {Component, Input} from '@angular/core';
import {ZoneTileType1} from "../../models";
import {ViewsService, ZonesService} from "../../core";

@Component({
    selector: 'temperature-sensor',
    templateUrl: './temperature-sensor.component.html',
    styleUrls: ['./temperature-sensor.component.scss']
})
export class TemperatureSensorComponent {
    @Input() tile: ZoneTileType1;

    constructor(
        public views: ViewsService,
        public zones: ZonesService,
    ) {
    }
}
